/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    FILTER PANEL
\*------------------------------------*/
class FilterPanel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var $primaryToggle = $('.js-filter-panel__primary-toggle'),
            $secondaryToggle = $('.js-filter-panel__secondary-toggle'),
            $mainPanel = $('.js-filter-panel__main'),
            $secondaryFields = $('.js-filter-panel__secondary-fields');

        // toggle primary panel
        $primaryToggle.on('click', function(evt) {
            // toggle is-active class on toggle element
            $(this).toggleClass('is-active');

            // toggle visibility of main panel
            $mainPanel.slideToggle(400, function() {
                // if we're hiding the main panel, also hide the secondary fields panel
                if($mainPanel.is(':hidden')) {
                    $secondaryToggle.removeClass('is-active');
                    $secondaryFields.hide();
                }
            });
        });

        // toggle secondary panel
        $secondaryToggle.on('click', function(evt) {
            $(this).toggleClass('is-active');

            $secondaryFields.slideToggle();
        });

        // reset form
        $('.js-filter-panel-reset-button').on('click', function() {
            var $form = $(this).closest('form');

            $form.find('select').val('');
            $form.find('input[type=checkbox]').prop('checked', false);
        });
    }
}

export default FilterPanel;
